import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=140462fc&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=140462fc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140462fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140462fc')) {
      api.createRecord('140462fc', component.options)
    } else {
      api.reload('140462fc', component.options)
    }
    module.hot.accept("./addGoods.vue?vue&type=template&id=140462fc&scoped=true", function () {
      api.rerender('140462fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/addGoods/addGoods.vue"
export default component.exports